export * from './objekte-list.component';
export * from './objekte-list.component.module';